// import React, { useState, useEffect, useRef } from "react";
// import { Calendar, ChevronLeft, ChevronRight } from "lucide-react";
// import initialRoom from "../../../data/rooms.json";
// import initialReservation from "../../../data/bookings.json";
// // import { Button } from 'bootstrap';

// const HotelBookingCalendar = () => {
//   const [rooms, setRooms] = useState(initialRoom);
//   const [reservations, setReservations] = useState(initialReservation);
//   const [currentWeekStart, setCurrentWeekStart] = useState(new Date());
//   const [expandedSections, setExpandedSections] = useState({
//     deluxe: true,
//     suite: true,
//     standard: true,
//   });
//   const [selectedBooking, setSelectedBooking] = useState(null);
//   const [selectedRoom, setSelectedRoom] = useState(null);
//   const [selectedDate, setSelectedDate] = useState(null);
//   const [showSidebar, setShowSidebar] = useState(false);
//   const [draggedBooking, setDraggedBooking] = useState(null);
//   const [showDatePicker, setShowDatePicker] = useState(false);
//   const [resizing, setResizing] = useState(null);
//   const [newBooking, setNewBooking] = useState({
//     guest_name: "",
//     checkin: "",
//     checkout: "",
//     status: "reserved",
//     platform: "direct",
//   });

//   const cellWidthRef = useRef(120);

//   // Generate 7 days from current week start
//   const getWeekDates = () => {
//     const dates = [];
//     for (let i = 0; i < 7; i++) {
//       const date = new Date(currentWeekStart);
//       date.setDate(date.getDate() + i);
//       dates.push({
//         day: date.toLocaleDateString("en-US", {
//           weekday: "short",
//           day: "2-digit",
//         }),
//         date: date.toISOString().split("T")[0],
//       });
//     }
//     return dates;
//   };

//   const dates = getWeekDates();

//   // load data
//   useEffect(() => {
//     setRooms(initialRoom);
//     setReservations(initialReservation);

//     const sections = {};
//     [...new Set(initialRoom.map((r) => r.room_type))].forEach((t) => {
//       sections[t.toLowerCase()] = true;
//     });
//     setExpandedSections(sections);
//   }, []);

//   // Navigation
//   const prevDay = () => {
//     const newDate = new Date(currentWeekStart);
//     newDate.setDate(newDate.getDate() - 1);
//     setCurrentWeekStart(newDate);
//   };

//   const nextDay = () => {
//     const newDate = new Date(currentWeekStart);
//     newDate.setDate(newDate.getDate() + 1);
//     setCurrentWeekStart(newDate);
//   };

//   const handleTodayClick = () => {
//     setCurrentWeekStart(new Date()); // jump to today
//   };

//   // Calculate stats
//   const calculateStats = () => {
//     const stats = { all: rooms.length, vacant: 0, occupied: 0, reserved: 0 };
//     const today = dates[0]?.date;

//     rooms.forEach((room) => {
//       const hasBooking = reservations.some(
//         (r) => r.room_id === room.id && today >= r.checkin && today < r.checkout
//       );
//       if (!hasBooking) stats.vacant++;
//       else {
//         const booking = reservations.find(
//           (r) =>
//             r.room_id === room.id && today >= r.checkin && today < r.checkout
//         );
//         if (booking?.status === "occupied") stats.occupied++;
//         if (booking?.status === "reserved") stats.reserved++;
//       }
//     });
//     return stats;
//   };

//   const stats = calculateStats();

//   // Booking colors
//   const getBookingColor = (status) => {
//     const colors = {
//       checkout: "#4a1100ff",
//       checkin: "#001effff",
//       occupied: "#ff1900ff",
//       reserved: "#00ff08ff",
//     };
//     return colors[status] || "#969696ff";
//   };

//   // Platform icons
//   const platformIcons = {
//     booking: "🅱️",
//     agoda: "✈️",
//     airbnb: "🏠",
//     mmt: "🅼",
//     goibibo: "🅶",
//     direct: "🏨",
//   };

//   // Calculate booking position and span
//   const calculateBookingSpan = (checkin, checkout) => {
//     const startIdx = dates.findIndex((d) => d.date === checkin);
//     const endIdx = dates.findIndex((d) => d.date === checkout);
//     if (startIdx === -1) return { start: -1, span: 0 };
//     return {
//       start: startIdx,
//       span: (endIdx !== -1 ? endIdx : dates.length) - startIdx,
//     };
//   };

//   // Drag and Drop handlers
//   const handleDragStart = (e, booking) => {
//     setDraggedBooking(booking);
//     e.dataTransfer.effectAllowed = "move";
//   };

//   const handleDragOver = (e) => {
//     e.preventDefault();
//     e.dataTransfer.dropEffect = "move";
//   };

//   const handleDrop = (e, roomId, newCheckin) => {
//     e.preventDefault();
//     if (!draggedBooking) return;

//     const oldCheckin = new Date(draggedBooking.checkin);
//     const newCheckinDate = new Date(newCheckin);

//     if (newCheckinDate < oldCheckin) {
//       setDraggedBooking(null);
//       return;
//     }
//     const oldCheckout = new Date(draggedBooking.checkout);
//     const duration = Math.floor(
//       (oldCheckout - oldCheckin) / (1000 * 60 * 60 * 24)
//     );

//     const newCheckout = new Date(newCheckin);
//     newCheckout.setDate(newCheckout.getDate() + duration);

//     setReservations((prev) =>
//       prev.map((res) =>
//         res.id === draggedBooking.id
//           ? {
//               ...res,
//               room_id: roomId,
//               checkin: newCheckin,
//               checkout: newCheckout.toISOString().split("T")[0],
//             }
//           : res
//       )
//     );
//     setDraggedBooking(null);
//   };

//   // Resize handlers
//   const handleResizeStart = (e, booking) => {
//     e.stopPropagation();
//     setResizing({ bookingId: booking.id, startX: e.clientX });
//   };

//   const handleResizeMove = (e) => {
//     if (!resizing) return;
//     const diffX = e.clientX - resizing.startX;
//     const daysMoved = Math.round(diffX / cellWidthRef.current);
//     if (daysMoved === 0) return;

//     setReservations((prev) =>
//       prev.map((res) => {
//         if (res.id !== resizing.bookingId) return res;
//         const checkinDate = new Date(res.checkin);
//         const checkoutDate = new Date(res.checkout);
//         const currentDuration = Math.floor(
//           (checkoutDate - checkinDate) / (1000 * 60 * 60 * 24)
//         );
//         const newDuration = Math.max(1, currentDuration + daysMoved);
//         const newCheckout = new Date(checkinDate);
//         newCheckout.setDate(checkinDate.getDate() + newDuration);
//         return { ...res, checkout: newCheckout.toISOString().split("T")[0] };
//       })
//     );

//     setResizing({ ...resizing, startX: e.clientX });
//   };

//   const handleResizeEnd = () => {
//     setResizing(null);
//   };

//   useEffect(() => {
//     if (resizing) {
//       document.addEventListener("mousemove", handleResizeMove);
//       document.addEventListener("mouseup", handleResizeEnd);
//       return () => {
//         document.removeEventListener("mousemove", handleResizeMove);
//         document.removeEventListener("mouseup", handleResizeEnd);
//       };
//     }
//   }, [resizing]);

//   // Render booking bar
//   const renderBooking = (reservation, room, dateIndex) => {
//     const { start, span } = calculateBookingSpan(
//       reservation.checkin,
//       reservation.checkout
//     );
//     if (start !== dateIndex || span <= 0) return null;

//     const color = getBookingColor(reservation.status);
//     const platformIcon = platformIcons[reservation.platform] || "🏨";

//     return (
//       <div
//         key={reservation.id}
//         draggable
//         onDragStart={(e) => handleDragStart(e, reservation)}
//         onClick={() => {
//           setSelectedBooking({
//             ...reservation,
//             room_number: room.room_number,
//             room_type: room.room_type,
//           });
//           setShowSidebar(true);
//         }}
//         style={{
//           position: "absolute",
//           top: "50%",
//           left: "6px",
//           transform: "translateY(-50%)",
//           width: `calc(${span * 100}% - 12px)`,
//           background: color,
//           borderRadius: "50px",
//           color: "white",
//           fontSize: "23px",
//           fontWeight: "600",
//           padding: "6px 10px",
//           cursor: "grab",
//           display: "flex",
//           alignItems: "center",
//           gap: "10px",
//           boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
//           zIndex: 2,
//           transition: "transform 0.15s ease, box-shadow 0.15s ease",
//         }}
//         onMouseEnter={(e) => {
//           e.currentTarget.style.transform = "translateY(-50%) scale(1.03)";
//           e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.25)";
//         }}
//         onMouseLeave={(e) => {
//           e.currentTarget.style.transform = "translateY(-50%)";
//           e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.2)";
//         }}
//       >
//         <span
//           style={{
//             position: "relative",
//             width: "25px",
//             height: "25px",
//             borderRadius: "50%",
//             background: "white",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             fontSize: "13px",
//             flexShrink: 0,
//           }}
//         >
//           {platformIcon}
//         </span>
//         <span
//           style={{
//             flex: 1,
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//             whiteSpace: "nowrap",
//           }}
//         >
//           {reservation.guest_name}
//         </span>
//         {reservation.payment_status === "pending" ? (
//           <div
//             style={{
//               position: "absolute",
//               top: "-5px",
//               right: "-5px",
//               backgroundColor: "#ef4444",
//               color: "white",
//               borderRadius: "50%",
//               width: "18px",
//               height: "18px",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               fontSize: "10px",
//               fontWeight: "700",
//               border: "2px solid white",
//             }}
//           >
//             $
//           </div>
//         ) : (
//           <div
//             style={{
//               position: "absolute",
//               top: "-5px",
//               right: "-5px",
//               backgroundColor: "#10b981",
//               color: "white",
//               borderRadius: "50%",
//               width: "18px",
//               height: "18px",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               fontSize: "10px",
//               fontWeight: "700",
//               border: "2px solid white",
//             }}
//           >
//             ✓
//           </div>
//         )}

//         <div
//           onMouseDown={(e) => handleResizeStart(e, reservation)}
//           style={{
//             width: "6px",
//             height: "100%",
//             position: "absolute",
//             right: 0,
//             top: 0,
//             cursor: "ew-resize",
//             background: "rgba(255,255,255,0.3)",
//             borderRadius: "0 12px 12px 0",
//           }}
//         />
//       </div>
//     );
//   };

//   // Room types
//   const roomTypes = [...new Set(rooms.map((r) => r.room_type))];
//   const getRoomsByType = (type) => rooms.filter((r) => r.room_type === type);

//   // Handle cell click for new booking
//   const handleCellClick = (room, date) => {
//     const hasBooking = reservations.some(
//       (r) => r.room_id === room.id && date >= r.checkin && date < r.checkout
//     );
//     if (!hasBooking) {
//       setSelectedRoom(room);
//       setSelectedDate(date);
//       setSelectedBooking(null);
//       const nextDay = new Date(date);
//       nextDay.setDate(nextDay.getDate() + 1);
//       setNewBooking({
//         guest_name: "",
//         checkin: date,
//         checkout: nextDay.toISOString().split("T")[0],
//         status: "reserved",
//         platform: "direct",
//       });
//       setShowSidebar(true);
//     }
//   };

//   // Handle booking save
//   const handleSaveBooking = () => {
//     if (!newBooking.guest_name) return;

//     const booking = {
//       id: Date.now(),
//       room_id: selectedRoom.id,
//       guest_name: newBooking.guest_name,
//       checkin: newBooking.checkin,
//       checkout: newBooking.checkout,
//       status: newBooking.status,
//       platform: newBooking.platform,
//     };
//     setReservations((prev) => [...prev, booking]);
//     setShowSidebar(false);
//     setNewBooking({
//       guest_name: "",
//       checkin: "",
//       checkout: "",
//       status: "reserved",
//       platform: "direct",
//     });
//   };

//   const [activeFilter, setActiveFilter] = useState("All");

//   const getButtonStyle = (label) => ({
//     display: "inline-flex",
//     alignItems: "center",
//     gap: "4px",
//     padding: "6px 10px",
//     borderRadius: "16px",
//     fontSize: "13px",
//     fontWeight: "500",
//     cursor: "pointer",
//     border: "none",
//     background: activeFilter === label ? "#1d4ed8" : "#0055ff55",
//     color: activeFilter === label ? "white" : "#111",
//     transition: "all 0.2s ease-in-out",
//   });

//   const badgeStyle = {
//     background: "#f3f4f6",
//     color: "#111",
//     borderRadius: "50%",
//     width: "22px",
//     height: "22px",
//     display: "inline-flex",
//     alignItems: "center",
//     justifyContent: "center",
//     marginLeft: "4px",
//     fontWeight: "600",
//   };

//   return (
//     <div
//       style={{
//         fontFamily:
//           '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
//         background: "#f5f5f5",
//         minHeight: "100vh",
//       }}
//     >
//       {/* Header */}
//       <div
//         style={{
//           background: "white",
//           padding: "16px 24px",
//           borderBottom: "1px solid #e0e0e0",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: "16px",
//             flexWrap: "wrap",
//           }}
//         >
//           <input
//             style={{
//               display: "flex",
//               alignItems: "center",
//               padding: "8px 14px",
//               borderRadius: "8px",
//               fontWeight: "600",
//               cursor: "pointer",
//             }}
//             type="date"
//             value={currentWeekStart.toISOString().split("T")[0]}
//             onChange={(e) => {
//               setCurrentWeekStart(new Date(e.target.value));
//               setShowDatePicker(false);
//             }}
//           />

//           <button
//             onClick={handleTodayClick}
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               gap: "4px",
//               padding: "6px 10px",
//               background: "#000000ff",
//               color: "white",
//               borderRadius: "1px",
//               fontSize: "15px",
//               fontWeight: "600",
//             }}
//           >
//             Today
//           </button>

//           <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
//             <button
//               style={getButtonStyle("All")}
//               onClick={() => setActiveFilter("All")}
//             >
//               All <span style={badgeStyle}>{stats.all}</span>
//             </button>

//             <button
//               style={getButtonStyle("Vacant")}
//               onClick={() => setActiveFilter("Vacant")}
//             >
//               Vacant <span style={badgeStyle}>{stats.vacant}</span>
//             </button>

//             <button
//               style={getButtonStyle("Occupied")}
//               onClick={() => setActiveFilter("Occupied")}
//             >
//               Occupied <span style={badgeStyle}>{stats.occupied}</span>
//             </button>

//             <button
//               style={getButtonStyle("Reserved")}
//               onClick={() => setActiveFilter("Reserved")}
//             >
//               Reserved <span style={badgeStyle}>{stats.reserved}</span>
//             </button>

//             <button
//               style={getButtonStyle("Booked")}
//               onClick={() => setActiveFilter("Booked")}
//             >
//               Booked <span style={badgeStyle}>{stats.booked}</span>
//             </button>

//             <button
//               style={getButtonStyle("Due Out")}
//               onClick={() => setActiveFilter("Due Out")}
//             >
//               Due Out <span style={badgeStyle}>{stats.dueOut}</span>
//             </button>

//             <button
//               style={getButtonStyle("Dirty")}
//               onClick={() => setActiveFilter("Dirty")}
//             >
//               Dirty <span style={badgeStyle}>{stats.dirty}</span>
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Calendar Body */}
//       <div style={{ padding: "24px" }}>
//         <div
//           style={{
//             background: "white",
//             borderRadius: "8px",
//             boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
//             overflow: "hidden",
//           }}
//         >
//           {/* Header Row */}
//           <div
//             style={{
//               display: "flex",
//               borderBottom: "2px solid #e0e0e0",
//               position: "relative",
//             }}
//           >
//             <div
//               style={{
//                 width: "140px",
//                 background: "#f8f9fa",
//                 borderRight: "1px solid #e0e0e0",
//                 padding: "12px",
//                 fontWeight: "600",
//               }}
//             >
//               Room Type
//             </div>
//             <button
//               onClick={prevDay}
//               style={{
//                 position: "absolute",
//                 left: "120px",
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 background: "#1e293b",
//                 color: "white",
//                 border: "none",
//                 borderRadius: "50%",
//                 width: "28px",
//                 height: "28px",
//                 cursor: "pointer",
//                 zIndex: 5,
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//               }}
//             >
//               <ChevronLeft size={16} />
//             </button>
//             {dates.map((date, i) => (
//               <div
//                 key={i}
//                 style={{
//                   flex: 1,
//                   textAlign: "center",
//                   background: "#f8f9fa",
//                   borderRight: "1px solid #e0e0e0",
//                   padding: "12px",
//                   fontSize: "12px",
//                   color: "#666",
//                 }}
//               >
//                 {date.day}
//               </div>
//             ))}
//             <button
//               onClick={nextDay}
//               style={{
//                 position: "absolute",
//                 right: "8px",
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 background: "#1e293b",
//                 color: "white",
//                 border: "none",
//                 borderRadius: "50%",
//                 width: "28px",
//                 height: "28px",
//                 cursor: "pointer",
//                 zIndex: 5,
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//               }}
//             >
//               <ChevronRight size={16} />
//             </button>
//           </div>

//           {/* Room Rows */}
//           {roomTypes.map((type) => (
//             <div key={type}>
//               <div
//                 style={{
//                   display: "flex",
//                   background: "#ffe6e6",
//                   borderBottom: "1px solid #e0e0e0",
//                 }}
//               >
//                 <div
//                   style={{
//                     width: "140px",
//                     borderRight: "1px solid #e0e0e0",
//                     display: "flex",
//                     alignItems: "center",
//                     padding: "12px",
//                     gap: "8px",
//                   }}
//                 >
//                   <button
//                     onClick={() =>
//                       setExpandedSections((prev) => ({
//                         ...prev,
//                         [type.toLowerCase()]: !prev[type.toLowerCase()],
//                       }))
//                     }
//                     style={{
//                       background: "white",
//                       border: "1px solid #ddd",
//                       borderRadius: "4px",
//                       padding: "2px 8px",
//                       cursor: "pointer",
//                       fontSize: "14px",
//                       fontWeight: "600",
//                     }}
//                   >
//                     {expandedSections[type.toLowerCase()] ? "−" : "+"}
//                   </button>
//                   <span style={{ fontWeight: "600" }}>{type}</span>
//                 </div>
//                 {dates.map((_, i) => (
//                   <div
//                     key={i}
//                     style={{
//                       flex: 1,
//                       borderRight: "1px solid #e0e0e0",
//                       padding: "8px",
//                       textAlign: "center",
//                       fontWeight: "600",
//                     }}
//                   >
//                     {
//                       getRoomsByType(type).filter(
//                         (room) =>
//                           !reservations.some(
//                             (r) =>
//                               r.room_id === room.id &&
//                               dates[i].date >= r.checkin &&
//                               dates[i].date < r.checkout
//                           )
//                       ).length
//                     }
//                   </div>
//                 ))}
//               </div>

//               {expandedSections[type.toLowerCase()] &&
//                 getRoomsByType(type).map((room) => {
//                   const roomReservations = reservations.filter(
//                     (r) => r.room_id === room.id
//                   );
//                   return (
//                     <div
//                       key={room.id}
//                       style={{
//                         display: "flex",
//                         alignItems: "stretch",
//                         borderBottom: "1px solid #e0e0e0",
//                         background: "white",
//                       }}
//                     >
//                       <div
//                         style={{
//                           width: "140px",
//                           borderRight: "1px solid #e0e0e0",
//                           padding: "12px",
//                           textAlign: "center",
//                           fontWeight: "700",
//                         }}
//                       >
//                         {room.room_number}
//                       </div>
//                       {dates.map((date, idx) => (
//                         <div
//                           key={idx}
//                           onDrop={(e) => handleDrop(e, room.id, date.date)}
//                           onDragOver={handleDragOver}
//                           onClick={() => handleCellClick(room, date.date)}
//                           style={{
//                             flex: 1,
//                             position: "relative",
//                             minHeight: "70px",
//                             borderRight: "1px solid #e0e0e0",
//                             cursor: "pointer",
//                             transition: "background 0.15s ease",
//                           }}
//                           onMouseEnter={(e) =>
//                             (e.currentTarget.style.background = "#fafafa")
//                           }
//                           onMouseLeave={(e) =>
//                             (e.currentTarget.style.background = "white")
//                           }
//                         >
//                           {roomReservations.map((res) =>
//                             renderBooking(res, room, idx)
//                           )}
//                         </div>
//                       ))}
//                     </div>
//                   );
//                 })}
//             </div>
//           ))}
//         </div>
//         {/* Room Availability Row */}
//         <div
//           style={{
//             display: "flex",
//             borderTop: "2px solid #ffe6e6",
//             background: "#ffe6e6",
//           }}
//         >
//           <div
//             style={{
//               width: "140px",
//               background: "#f8f9fa",
//               borderRight: "1px solid #e0e0e0",
//               padding: "12px",
//               fontWeight: "700",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             Room Availability
//           </div>
//           {dates.map((date, i) => {
//             const available = rooms.filter(
//               (room) =>
//                 !reservations.some(
//                   (r) =>
//                     r.room_id === room.id &&
//                     date.date >= r.checkin &&
//                     date.date < r.checkout
//                 )
//             ).length;
//             return (
//               <div
//                 key={i}
//                 style={{
//                   flex: 1,
//                   borderRight: "1px solid #e0e0e0",
//                   padding: "12px",
//                   textAlign: "center",
//                   fontWeight: "600",
//                 }}
//               >
//                 {available}
//               </div>
//             );
//           })}
//         </div>

//         {/* Occupancy Row */}
//         <div style={{ display: "flex", background: "#ffe6e6" }}>
//           <div
//             style={{
//               width: "140px",
//               background: "#f8f9fa",
//               borderRight: "1px solid #e0e0e0",
//               padding: "12px",
//               fontWeight: "700",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             Occupancy (%)
//           </div>
//           {dates.map((date, i) => {
//             const occupied = reservations.filter(
//               (r) => date.date >= r.checkin && date.date < r.checkout
//             ).length;
//             const occupancyPercent = Math.round(
//               (occupied / rooms.length) * 100
//             );
//             return (
//               <div
//                 key={i}
//                 style={{
//                   flex: 1,
//                   borderRight: "1px solid #e0e0e0",
//                   padding: "12px",
//                   textAlign: "center",
//                   fontWeight: "600",
//                 }}
//               >
//                 {occupancyPercent}%
//               </div>
//             );
//           })}
//         </div>
//       </div>

//       {/* Sidebar */}
//       {showSidebar && (
//         <>
//           <div
//             style={{
//               position: "fixed",
//               inset: 0,
//               background: "rgba(0,0,0,0.5)",
//               zIndex: 1000,
//               animation: "fadeIn 0.2s ease",
//             }}
//             onClick={() => setShowSidebar(false)}
//           />
//           <div
//             style={{
//               position: "fixed",
//               right: 0,
//               top: 0,
//               bottom: 0,
//               width: "420px",
//               background: "white",
//               boxShadow: "-4px 0 12px rgba(0,0,0,0.15)",
//               zIndex: 1001,
//               display: "flex",
//               flexDirection: "column",
//               animation: "slideInRight 0.3s ease",
//             }}
//           >
//             <div
//               style={{
//                 background: "#1e3a8a",
//                 color: "white",
//                 padding: "16px 20px",
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//               }}
//             >
//               <h5 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>
//                 {selectedBooking ? "Booking Details" : "Add New Booking"}
//               </h5>
//               <button
//                 onClick={() => setShowSidebar(false)}
//                 style={{
//                   background: "none",
//                   border: "none",
//                   color: "white",
//                   fontSize: "24px",
//                   cursor: "pointer",
//                   padding: "0",
//                   lineHeight: "1",
//                 }}
//               >
//                 ×
//               </button>
//             </div>

//             <div style={{ flex: 1, overflow: "auto", padding: "20px" }}>
//               {selectedBooking ? (
//                 <div>
//                   <p style={{ marginBottom: "12px" }}>
//                     <strong>Guest:</strong> {selectedBooking.guest_name}
//                   </p>
//                   <p style={{ marginBottom: "12px" }}>
//                     <strong>Room:</strong> {selectedBooking.room_number}
//                   </p>
//                   <p style={{ marginBottom: "12px" }}>
//                     <strong>Type:</strong> {selectedBooking.room_type}
//                   </p>
//                   <p style={{ marginBottom: "12px" }}>
//                     <strong>Status:</strong> {selectedBooking.status}
//                   </p>
//                   <p style={{ marginBottom: "12px" }}>
//                     <strong>Check-in:</strong> {selectedBooking.checkin}
//                   </p>
//                   <p style={{ marginBottom: "12px" }}>
//                     <strong>Check-out:</strong> {selectedBooking.checkout}
//                   </p>
//                   <p style={{ marginBottom: "12px" }}>
//                     <strong>Platform:</strong> {selectedBooking.platform}
//                   </p>
//                 </div>
//               ) : (
//                 <div>
//                   <p style={{ marginBottom: "12px" }}>
//                     <strong>Room:</strong> {selectedRoom?.room_number}
//                   </p>
//                   <p style={{ marginBottom: "20px" }}>
//                     <strong>Date:</strong> {selectedDate}
//                   </p>

//                   <div style={{ marginBottom: "16px" }}>
//                     <label
//                       style={{
//                         display: "block",
//                         marginBottom: "6px",
//                         fontSize: "13px",
//                         fontWeight: "600",
//                         color: "#374151",
//                       }}
//                     >
//                       Guest Name
//                     </label>
//                     <input
//                       type="text"
//                       value={newBooking.guest_name}
//                       onChange={(e) =>
//                         setNewBooking({
//                           ...newBooking,
//                           guest_name: e.target.value,
//                         })
//                       }
//                       style={{
//                         width: "100%",
//                         padding: "10px",
//                         border: "1px solid #d1d5db",
//                         borderRadius: "6px",
//                         fontSize: "14px",
//                       }}
//                       placeholder="Enter guest name"
//                     />
//                   </div>

//                   <div
//                     style={{
//                       display: "flex",
//                       gap: "12px",
//                       marginBottom: "16px",
//                     }}
//                   >
//                     <div style={{ flex: 1 }}>
//                       <label
//                         style={{
//                           display: "block",
//                           marginBottom: "6px",
//                           fontSize: "13px",
//                           fontWeight: "600",
//                           color: "#374151",
//                         }}
//                       >
//                         Check-in
//                       </label>
//                       <input
//                         type="date"
//                         value={newBooking.checkin}
//                         onChange={(e) =>
//                           setNewBooking({
//                             ...newBooking,
//                             checkin: e.target.value,
//                           })
//                         }
//                         style={{
//                           width: "100%",
//                           padding: "10px",
//                           border: "1px solid #d1d5db",
//                           borderRadius: "6px",
//                           fontSize: "14px",
//                         }}
//                       />
//                     </div>
//                     <div style={{ flex: 1 }}>
//                       <label
//                         style={{
//                           display: "block",
//                           marginBottom: "6px",
//                           fontSize: "13px",
//                           fontWeight: "600",
//                           color: "#374151",
//                         }}
//                       >
//                         Check-out
//                       </label>
//                       <input
//                         type="date"
//                         value={newBooking.checkout}
//                         onChange={(e) =>
//                           setNewBooking({
//                             ...newBooking,
//                             checkout: e.target.value,
//                           })
//                         }
//                         style={{
//                           width: "100%",
//                           padding: "10px",
//                           border: "1px solid #d1d5db",
//                           borderRadius: "6px",
//                           fontSize: "14px",
//                         }}
//                       />
//                     </div>
//                   </div>

//                   <div style={{ marginBottom: "16px" }}>
//                     <label
//                       style={{
//                         display: "block",
//                         marginBottom: "6px",
//                         fontSize: "13px",
//                         fontWeight: "600",
//                         color: "#374151",
//                       }}
//                     >
//                       Status
//                     </label>
//                     <select
//                       value={newBooking.status}
//                       onChange={(e) =>
//                         setNewBooking({ ...newBooking, status: e.target.value })
//                       }
//                       style={{
//                         width: "100%",
//                         padding: "10px",
//                         border: "1px solid #d1d5db",
//                         borderRadius: "6px",
//                         fontSize: "14px",
//                       }}
//                     >
//                       <option value="reserved">Reserved</option>
//                       <option value="checkin">Check-in</option>
//                       <option value="occupied">Occupied</option>
//                       <option value="checkout">Checkout</option>
//                     </select>
//                   </div>

//                   <div style={{ marginBottom: "20px" }}>
//                     <label
//                       style={{
//                         display: "block",
//                         marginBottom: "6px",
//                         fontSize: "13px",
//                         fontWeight: "600",
//                         color: "#374151",
//                       }}
//                     >
//                       Platform
//                     </label>
//                     <select
//                       value={newBooking.platform}
//                       onChange={(e) =>
//                         setNewBooking({
//                           ...newBooking,
//                           platform: e.target.value,
//                         })
//                       }
//                       style={{
//                         width: "100%",
//                         padding: "10px",
//                         border: "1px solid #d1d5db",
//                         borderRadius: "6px",
//                         fontSize: "14px",
//                       }}
//                     >
//                       <option value="direct">Direct</option>
//                       <option value="booking">Booking.com</option>
//                       <option value="airbnb">Airbnb</option>
//                       <option value="agoda">Agoda</option>
//                     </select>
//                   </div>

//                   <div style={{ display: "flex", gap: "10px" }}>
//                     <button
//                       onClick={handleSaveBooking}
//                       style={{
//                         flex: 1,
//                         background: "#2563eb",
//                         color: "white",
//                         border: "none",
//                         borderRadius: "8px",
//                         padding: "10px",
//                         fontSize: "14px",
//                         fontWeight: "600",
//                         cursor: "pointer",
//                       }}
//                     >
//                       Save Booking
//                     </button>
//                     <button
//                       onClick={() => setShowSidebar(false)}
//                       style={{
//                         flex: 1,
//                         background: "#e5e7eb",
//                         color: "#374151",
//                         border: "none",
//                         borderRadius: "8px",
//                         padding: "10px",
//                         fontSize: "14px",
//                         fontWeight: "500",
//                         cursor: "pointer",
//                       }}
//                     >
//                       Cancel
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>

//           <style>{`
//           @keyframes fadeIn {
//             from { opacity: 0; }
//             to { opacity: 1; }
//           }
//           @keyframes slideInRight {
//             from { transform: translateX(100%); }
//             to { transform: translateX(0); }
//           }
//         `}</style>
//         </>
//       )}
//     </div>
//   );
// };

// export default HotelBookingCalendar;

import React, { useEffect, useState } from "react";
import CalendarGrid from "./components/Calendar/CalendarGrid";
import {
  fetchCalendarData,
  fetchRateTypes,
  fetchReservations,
  fetchRooms,
} from "./services/api";

// Sample Data
const ROOMS = [
  { id: 1, room_number: "101", type: "Standard", price: 100 },
  { id: 2, room_number: "102", type: "Standard", price: 100 },
  { id: 3, room_number: "103", type: "Standard", price: 100 },
  { id: 4, room_number: "201", type: "Deluxe", price: 150 },
  { id: 5, room_number: "202", type: "Deluxe", price: 150 },
  { id: 6, room_number: "301", type: "Suite", price: 250 },
];

const INITIAL_RESERVATIONS = [
  {
    id: 1,
    property_code: "HEZEE002",
    room_id: 1,
    guest_id: 1,
    status: "checked_in",
    check_in: "2024-05-01T14:00:00.000000Z",
    check_out: "2024-05-05T11:00:00.000000Z",
    adults: 2,
    children: 1,
    booking_type: "Walk-in",
    booking_reference_no: "B123456",
    arrival_from: "Web",
    purpose_of_visit: "Leisure",
    remarks: "Late check-in",
    total: 400,
    guest: {
      id: 1,
      property_code: "HEZEE002",
      title: "Mr",
      name: "John Doe",
      father_name: "Richard Doe",
      email: "john@example.com",
      mobile: "1234567890",
    },
  },
  {
    id: 2,
    property_code: "HEZEE002",
    room_id: 4,
    guest_id: 2,
    status: "confirmed",
    check_in: "2024-05-03T14:00:00.000000Z",
    check_out: "2024-05-07T11:00:00.000000Z",
    adults: 1,
    children: 0,
    booking_type: "Online",
    booking_reference_no: "B654321",
    arrival_from: "OTA",
    purpose_of_visit: "Business",
    remarks: "",
    total: 600,
    guest: {
      id: 2,
      property_code: "HEZEE002",
      title: "Ms",
      name: "Jane Smith",
      father_name: "Robert Smith",
      email: "jane@example.com",
      mobile: "0987654321",
    },
  },
];

const HotelBookingCalendar = () => {
  const [rooms, setRooms] = useState([]);
  const [reservations, setReservations] = useState([]);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [loading, setLoading] = useState(true);
  const [rateTypes, setRateTypes] = useState([]);
  const [calenderData, setCalenderData] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      try {
        // const roomsData = await fetchRooms();
        // setRooms(roomsData);
        const reservationsData = await fetchReservations();
        setReservations(reservationsData);
        // const rateTypes = await fetchRateTypes();
        // setRateTypes(rateTypes);
        const calenderData = await fetchCalendarData();
        setCalenderData(calenderData);
      } catch (err) {
        console.error("Failed to load data", err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  const handleAddReservation = (reservation) => {
    console.log(reservation);
    setReservations([...reservations, reservation]);
  };

  const handleUpdateReservation = (updatedReservation) => {
    setReservations(
      reservations.map((r) =>
        r.id === updatedReservation.id ? updatedReservation : r
      )
    );
  };

  if (loading)
    return <div className="p-5 text-center">Loading calendar...</div>;

  return (
    <div>
      <CalendarGrid
        rooms={rooms}
        reservations={reservations}
        rateTypes={rateTypes}
        currentDate={currentDate}
        calendarData={calenderData}
        setCurrentDate={setCurrentDate}
        onUpdateReservation={handleUpdateReservation}
        onAddReservation={handleAddReservation}
      />
    </div>
  );
};

export default HotelBookingCalendar;
